import { all, takeLatest } from "redux-saga/effects";
import {
  QUOTE_LIST,
  QUOTE_DETAILS,
  UPDATE_QUOTE,
  DELETE_QUOTE,
  RESEND_QUOTE_TO_ZOHO,
} from "../actions/quote.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getQuoteList({ payload: { data, callback } }) {
  const payload = {
    params: data,
    method: "get",
    url: "quotes/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* quoteDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `quotes/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateQuote({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `quotes/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      // successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteQuote({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `quotes/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* resendQuoteToZoho({ payload: { id, callback } }) {
  const payload = {
    method: "post",
    url: `quotes/${id}/resend-zoho`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Quote() {
  yield all([
    takeLatest(QUOTE_LIST, getQuoteList),
    takeLatest(QUOTE_DETAILS, quoteDetails),
    takeLatest(UPDATE_QUOTE, updateQuote),
    takeLatest(DELETE_QUOTE, deleteQuote),
    takeLatest(RESEND_QUOTE_TO_ZOHO, resendQuoteToZoho),
  ]);
}

export default Quote;
